import { useTranslate } from "@similarweb/i18n-provider";
import { Flex } from "@similarweb/ui-components/foundations";

import { SettingsCard } from "app/pages/sales-intelligence/pages/management/components/SettingsCard/SettingsCard";
import { AI_WORKFLOW_CARDS } from "app/pages/sales-intelligence/pages/management/constants/extensionSettingsConfig";
import type { ExtensionSettings } from "app/pages/sales-intelligence/pages/management/types/types";
import extensionManagementTrackingService from "app/pages/sales-intelligence/modules/extension-management/tracking/trackingService";

import { SettingsSectionTitle } from "../SettingsSectionTitle/SettingsSectionTitle";

type AiWorkflowsSectionProps = {
    settings: ExtensionSettings;
    onToggle: (key: "enableGmailAgent" | "enableGoogleCalendarAgent") => void;
};

export const AiWorkflowsSection = ({ settings, onToggle }: AiWorkflowsSectionProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            flexWrap="wrap"
            gap="8px"
            width="100%"
        >
            <SettingsSectionTitle
                title={translate("si.management.extension.settings.ai_workflows.title")}
                dataAutomation="sales-intelligence-extension-ai-workflows"
            />
            {AI_WORKFLOW_CARDS.map((card) => (
                <SettingsCard
                    key={card.key}
                    icon={card.icon}
                    title={translate(card.titleKey)}
                    description={translate(card.descriptionKey)}
                    isSelected={settings[card.key]}
                    onToggle={() => {
                        extensionManagementTrackingService.trackSettingsToggle(card.key, settings[card.key]);
                        onToggle(card.key);
                    }}
                    isNew={card.isNew === true}
                    dataAutomation={`sales-intelligence-extension-settings-${card.key}`}
                />
            ))}
        </Flex>
    );
};
